import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  updateCustomerRequest,
  updateCustomerSuccess,
  updateCustomerFailure,
  updateKycDetailsRequest,
  updateKycDetailsSuccess,
  updateKycDetailsFailure,
  getCustomerRequest,
  getCustomerSuccess,
  getCustomerFailure,
  getVipActiveConfigurationsRequest,
  getVipActiveConfigurationsSuccess,
  getVipActiveConfigurationsFailure,
} from "./profileSlice";
import { toast } from "react-toastify";

function* updateCustomer(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/customer/updateCustomer`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response.data.success) {
      yield put(updateCustomerSuccess(response.data));
      toast.success(response.data.message || "Customer updated successfully");
      yield put(
        getCustomerRequest({
          phone: action.payload?.phone,
          jeweller:
            action.payload?.jeweller || process.env.REACT_APP_JEWELLER_ID,
          deviceDetails: action.payload?.deviceDetails || navigator.userAgent,
        }),
      );
    } else {
      yield put(
        updateCustomerFailure(
          response.data.message || "Failed to update customer",
        ),
      );
      toast.error(response.data.message || "Failed to update customer");
    }
  } catch (error) {
    yield put(
      updateCustomerFailure(error.response?.data?.message || error.message),
    );
  }
}

function* updateKycDetails(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/kyc/savekycdetails`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response.data.success) {
      yield put(updateKycDetailsSuccess(response.data));
      toast.success(
        response.data.message || "KYC Details updated successfully",
      );
      window.location.reload();
    } else {
      yield put(
        updateKycDetailsFailure(
          response.data.message || "Failed to update KYC Details",
        ),
      );
      toast.error(response.data.message || "Failed to update KYC Details");
    }
  } catch (error) {
    yield put(
      updateKycDetailsFailure(error.response?.data?.message || error.message),
    );
  }
}

function saveCustomerSession(data) {
  const accessToken = data?.accessToken;
  const refreshToken = data?.refreshToken;
  const customer = data?.customer;

  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("adminAccessToken", accessToken);
  }
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("adminRefreshToken", refreshToken);
  }
  if (customer) {
    localStorage.setItem("user", JSON.stringify(customer));
    localStorage.setItem("adminUserData", JSON.stringify(customer));
  }
}

function* fetchCustomer(action) {
  try {
    const customerPayload = action.payload || {};
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/customer/getCustomer`,
      customerPayload,
      {
        headers: {
          "Content-Type": "application/json",
          version: "1.2.0",
          newui: "true",
        },
      },
    );

    if (response.data?.success && response.data?.data?.customer) {
      saveCustomerSession(response.data.data);
      yield put(getCustomerSuccess(response.data));
    } else {
      yield put(
        getCustomerFailure(response.data?.message || "Failed to get customer"),
      );
    }
  } catch (error) {
    yield put(
      getCustomerFailure(error.response?.data?.message || error.message),
    );
  }
}

function* fetchVipActiveConfigurations() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/vip-customer/get-active-configurations`,
        {
          headers: {
            version: "1.2.0",
            newui: "true",
          },
        },
      ),
    );

    const data = response.data?.data;
    const hasConfig =
      response.data?.success &&
      data &&
      !Array.isArray(data) &&
      typeof data === "object";

    if (hasConfig) {
      yield put(getVipActiveConfigurationsSuccess(response.data));
    } else {
      yield put(getVipActiveConfigurationsSuccess({ data: null }));
    }
  } catch (error) {
    yield put(
      getVipActiveConfigurationsFailure(
        error.response?.data?.message || error.message,
      ),
    );
  }
}

export function* profileSaga() {
  yield takeLatest(updateCustomerRequest.type, updateCustomer);
  yield takeLatest(updateKycDetailsRequest.type, updateKycDetails);
  yield takeLatest(getCustomerRequest.type, fetchCustomer);
  yield takeLatest(
    getVipActiveConfigurationsRequest.type,
    fetchVipActiveConfigurations,
  );
}
